import commonReducer from './slices/common';

export default {
  commonReducer,
};
